// import Vue from "vue";
// import App from "./App.vue";

// Vue.config.productionTip = false;

// new Vue({
//     render: (h) => h(App),
// }).$mount("#app");

// 2020-07-02 Manfred Wuits manfred@monochrom.at

//font aweasome svgs:
import {
    library,
    dom
} from "@fortawesome/fontawesome-svg-core";


import * as solidIcons from './icons/solid';
library.add(...Object.values(solidIcons));

import * as lightIcons from './icons/light';
library.add(...Object.values(lightIcons));

import * as brandIcons from './icons/brands';
library.add(...Object.values(brandIcons));


dom.watch();

// jquery stuff:

jQuery(document).ready(function ($) {
    $(".leftnav > ul").on("click", "li > svg", function () {
        $(this)
            .parent()
            .toggleClass("expanded");
        $(this)
            .siblings(".submenu")
            .first()
            .slideToggle();
    });

    $("#search-form .search-icon").on("click", function (event) {
        $("#search-form").toggleClass("active");
        $("input", "#search-form").focus();
        event.preventDefault();
    });

    function is_touch_device() {
        // Checks for existence in all browsers and IE 10/11 & Surface
        return "ontouchstart" in window || navigator.maxTouchPoints;
    }
    // Initialise flickity
    var scroll = document.querySelector("#navigation-top-level-scrollable");
    var initialIndex = 0;
    var initialElement = null;

    for (var i = 0, len = scroll.childElementCount; i < len; ++i) {
        if (scroll.children[i].classList.contains("active")) {
            initialIndex = i;
            initialElement = scroll.children[i];
            break;
        }
    }
    if (is_touch_device()) {
        // console.log(`#log 9241`);
        document.querySelector("body").classList.add('is-touch-device');
        if (initialElement) {
            // console.log(`#log 6727`, scroll);
            jQuery.easing.easeOutBack = function (x, t, b, c, d, s) {
                if (s == undefined) s = 1.70158;
                return c * ((t = t / d - 1) * t * ((s + 1) * t + s) + 1) + b;
            };
            $(scroll).animate({
                    scrollLeft: initialElement.offsetLeft - 50
                },
                1200,
                "easeOutBack"
            );
        }
    } else {

        var maxElementIdx = 0;
        var lastMovingElementIdx = 0;
        var lastSelectedIdx = 0;

        function determineLastMovingElementIdx(f) {
            var lastTarget = -1;
            lastMovingElementIdx = -1;
            maxElementIdx = f.slides.length - 1;
            // console.log(`#log 7482`, maxElementIdx);
            f.slides.forEach(function (slide, idx) {
                if (lastMovingElementIdx == -1) {
                    if (lastTarget == slide.target) {
                        lastMovingElementIdx = idx - 1;
                    }
                    lastTarget = slide.target;
                }
            });

            // console.log(`#log 6126 lastMovingElementIdx,maxElementIdx`, lastMovingElementIdx, maxElementIdx);
            if (lastMovingElementIdx == 0) {
                scroll.classList.add('hide-scrollnav')
            } else {
                scroll.classList.remove('hide-scrollnav')
            }

        }
        var flickity = new Flickity(scroll, {
            cellAlign: "left",
            freeScroll: true,
            prevNextButtons: true,
            pageDots: false,
            contain: true,
            initialIndex: initialIndex - 1,
            on: {
                change: function (idx) {
                    if (idx != maxElementIdx) {
                        // console.log(`#log 1165`, lastSelectedIdx, '➜ ', idx, lastMovingElementIdx, maxElementIdx);
                        if (idx > lastSelectedIdx && idx >= lastMovingElementIdx) {
                            // next
                            // console.log(`#log 6467 selectMax`, maxElementIdx);
                            idx = maxElementIdx
                            this.selectCell(idx);
                        } else {
                            if (idx < lastSelectedIdx && idx > lastMovingElementIdx) {
                                // prev
                                idx = lastMovingElementIdx - 1
                                if (idx < 1) {
                                    idx = 0
                                }
                                this.selectCell(idx);
                            }
                        }
                    }

                    lastSelectedIdx = idx;
                },
                resize: function () {
                    determineLastMovingElementIdx(this);
                },
                ready: function name(params) {
                    determineLastMovingElementIdx(this);
                }
            }
        });
    }
});

// Public App-API
var App = (function () {
    return {
        /**
         * translation-method for our App. takes the given string {str} and searches for it in the {i18nDic}-object.
         * if not found the string itself is returned.
         * this has the advantage of not needing
         *     1. to invent keys and
         *     2. the source-language in a separate dic-file
         * translations are stored in js/lang/%lang%.js
         *
         * @param str
         * @returns the translation of the string or the string itself if not translated
         */
        t: function (str) {
            str;
        },

        /**
         * Returns a function, that, as long as it continues to be invoked, will not be triggered. The function will be called after it stops being called for
         * N milliseconds.
         * If `immediate` is passed, trigger the function on the leading edge, instead of the trailing.
         * source: https://davidwalsh.name/javascript-debounce-function
         *
         * usage:
         *   // will execute when user stopped scrolling for 250ms
         *   $(window).on('scroll', App.debounce(function () {
         *      // do stuff here
         *   }, 250));
         */
        debounce: function (func, wait, immediate) {
            var timeout;
            return function executedFunction() {
                var context = this,
                    args = arguments;

                var later = function () {
                    timeout = null;
                    if (!immediate) func.apply(context, args);
                };

                var callNow = immediate && !timeout;
                clearTimeout(timeout);
                timeout = setTimeout(later, wait);
                if (callNow) func.apply(context, args);
            };
        },

        /**
         * throttle the execution of the given function according to the repaint-interval of the browser (requestAnimationFrame)
         * use this function if your code will trigger re-paint-actions in the browser.
         * source: https://gist.github.com/jurebajt/dccf6cc62ab3aa55a2f096ef86d9f85d
         *
         * usage:
         *   $(document).on('scroll', App.rafThrottle(checkShrink));
         */
        rafThrottle: function (fn) {
            var busy = false;
            return function () {
                if (busy) return;
                busy = true;
                fn.apply(this, arguments);
                window.requestAnimationFrame(function () {
                    busy = false;
                });
            };
        },

        isTouchDevice: function () {
            return (
                true ==
                ("ontouchstart" in window ||
                    (window.DocumentTouch && document instanceof DocumentTouch))
            );
        },

        getMobileOS: function () {
            var userAgent =
                navigator.userAgent || navigator.vendor || window.opera;

            // Windows Phone must come first because its UA also contains "Android"
            if (/windows phone/i.test(userAgent)) {
                return "windows";
            }

            if (/android/i.test(userAgent)) {
                return "android";
            }

            if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
                return "ios";
            }

            return "unknown";
        }
    };
})();

// anonymous initialization wrapper
!(function (components) {
    // initialize all given components by executing the given function
    components.forEach(function (obj) {
        obj();
    });
})([
    function MobileNav() {
        // internal component methods
        var prepare = function () {
                var currentLevel = 0,
                    mobileHeaderWrapper = $("#mobileheader-wrapper"),
                    levelContainer = $(".levels"),
                    mobileNavToggler = $("#mobilenav-toggler"),
                    mobileNavigationLists = levelContainer.find("ul"),
                    mobileSearch = $("#mobile-search"),
                    page = $("#page"),
                    skiplinks = $("#skiplinks-container");

                // removing possibility to tab on a hidden mobile-navigation:
                mobileHeaderWrapper.css("display", "none");

                $(mobileHeaderWrapper).on("show.bs.collapse", function () {
                    mobileHeaderWrapper.css("display", "block");

                    page.css("display", "none");
                    skiplinks.css("display", "none");
                });
                $(mobileHeaderWrapper).on("scroll", function () {
                    $(this).scrollLeft(0);
                });

                // setting focus to first item of navigation, when opening
                $(mobileHeaderWrapper).on("shown.bs.collapse", function () {
                    // enabling possibility to tab on a hidden mobile-navigation:

                    // setting focus to first navigation element:
                    mobileHeaderWrapper
                        .find("a")
                        .first()
                        .focus();

                    // Hide all sub-Items + resetting data-active-level:
                    $("ul li .level-pos-container", levelContainer).hide();
                    mobileHeaderWrapper.removeAttr("data-active-level");
                });

                // setting focus back to burger when closing mobile navigation
                $(mobileHeaderWrapper).on("hide.bs.collapse", function () {
                    page.css("display", "block");
                    skiplinks.css("display", "block");
                    mobileHeaderWrapper.find("a").removeAttr("tabindex");
                });

                // setting focus back to burger when closing mobile navigation
                $(mobileHeaderWrapper).on("hidden.bs.collapse", function () {
                    // removing possibility to tab on a hidden mobile-navigation:
                    // $('a, button', mobileHeaderWrapper).attr('tabindex', -1);
                    mobileHeaderWrapper.css("display", "none");

                    // setting focus back to mobilenavigation-burger:
                    mobileNavToggler.focus();
                });

                $(mobileSearch).on("shown.bs.collapse", function (event) {
                    mobileSearch.find("input[type=text]:first").focus();
                    event.stopPropagation();
                });

                // Fix: Beim Schließen der Mobile-Search hat sich auch die Mobile-Navigation geschlossen (???)
                $(".mobile-search-toggler").on("click", function (event) {
                    $("#mobile-search").toggle();
                    event.stopPropagation();
                });

                // closing mobile navigation on Escape-Key
                $(levelContainer).on("keydown", function (e) {
                    if (e.keyCode == 27) {
                        $(mobileHeaderWrapper).collapse("hide");
                    }
                });

                // adding dummy-link (which is tab-able) to mobilewrapper
                // when this link is reached, the focus for the mobilen-navigation is set to the first item
                var mobileHeaderFocusHelper = $(
                    '<li class="focus-helper"><a href="#" aria-label="Ende der Liste"></a></li>'
                );
                $(mobileHeaderWrapper)
                    .find("ul")
                    .append(mobileHeaderFocusHelper);

                $(".focus-helper a").on("focusin", function () {
                    // setting focus to first navigation element:
                    mobileHeaderWrapper.find(".controls button:first").focus();
                });

                // prepare the structure of the navigation (surround lists with needed scroll- ans pos-containers)
                mobileNavigationLists.wrap(
                    '<div class="level-pos-container"><div class="level-scroll-container" tabindex="-1"></div></div>'
                );
                $("#mobile-nav-footer").appendTo(
                    $(".level-scroll-container").first()
                );

                // mark with hasChildren
                mobileNavigationLists.find("ul").each(function () {
                    var li = $(this)
                        .parents("li")
                        .first();
                    li.addClass("hasChildren");
                    li.children("a")
                        .append(
                            '<span class="sr-only">(öffnet Untermenüpunkte)</span>'
                        )
                        .append('<i class="fal fa-chevron-right"></i>');
                });

                // register click events for the mobile navigation entries
                levelContainer.find("ul li a").on("click", function () {
                    var link = $(this),
                        allLinks = levelContainer.find("a");

                    // referencing the outer-scope variable
                    currentLevel = link.parents("ul").length;

                    // hide the searchbar if visible and not user is not on the first level
                    if (
                        currentLevel > 0 &&
                        (!$(".navbar-back").is(":visible") ||
                            $(".mobile-search-toggler").is(":visible"))
                    ) {
                        if ($("#mobile-search").is(":visible")) {
                            $(".mobile-search-toggler").trigger("click");
                        }
                    }

                    var li = link.parent(),
                        ul = li.parent(),
                        parentLis = link.parents("li"),
                        allLis = levelContainer.find("li"),
                        nextLevel = li.find(".level-pos-container").first(),
                        scrollContainer = ul.parent(),
                        hasChildren = li.hasClass("hasChildren");

                    if (hasChildren) {
                        allLinks.removeClass("active current");
                        link.addClass("active current disabled");

                        allLis.removeClass("active");
                        parentLis.addClass("active");
                        parentLis.find("> a").addClass("active");
                        li.addClass("active");
                        ul.find("> li > a").addClass("disabled");

                        ul.find(".level-pos-container").hide();
                        scrollContainer.addClass("disabled");
                        nextLevel.show();

                        mobileHeaderWrapper.attr(
                            "data-active-level",
                            currentLevel
                        );

                        if (currentLevel > 0) {
                            var parentUl = ul.closest("ul");
                            parentUl.find("> li > a").attr("tabindex", "-1");
                            $("#mobile-nav-footer a").attr("tabindex", "-1");
                        }

                        // set focus on the first item:
                        window.setTimeout(function () {
                            nextLevel.find("a:visible:first").focus();
                        }, 200);

                        return false;
                    }
                });

                // events for mobile back-link in nav
                var fnNavBack = function () {
                    // nothing to go back anymore
                    if (currentLevel === 0) {
                        return false;
                    }

                    currentLevel--;
                    // first level of navigation, show actions for first level
                    if (currentLevel === 0) {
                        mobileHeaderWrapper.removeAttr("data-active-level");
                        $("#mobile-nav-footer a").removeAttr("tabindex");
                    } else {
                        mobileHeaderWrapper.attr(
                            "data-active-level",
                            currentLevel
                        );
                    }

                    var lastActiveLink = levelContainer.find("a.active").last(),
                        lastActiveLi = lastActiveLink.parents("li").first(),
                        lastActiveUl = lastActiveLi.parents("ul").first(),
                        lastActiveScrollContainer = lastActiveUl
                        .parents(".level-scroll-container")
                        .first();

                    lastActiveUl.find("> li > a").removeAttr("tabindex");
                    lastActiveLink.focus();

                    lastActiveLink.removeClass("active current disabled");
                    lastActiveLi.removeClass("active");
                    lastActiveUl.find("> li > a").removeClass("disabled");
                    lastActiveScrollContainer.removeClass("disabled");

                    lastActiveUl.find(".level-pos-container").hide();

                    return false;
                };

                $(".navbar-back").on("click", fnNavBack);
                // register swipe event on the root-navigation-list (not jquery-element)
                mobileNavigationLists
                    .get(0)
                    .addEventListener("swiped-right", fnNavBack);

                // events when closing the mobile-navbar
                mobileHeaderWrapper.on("hidden.bs.collapse", function () {
                    mobileHeaderWrapper.removeAttr("data-active-level");
                    mobileHeaderWrapper
                        .find(".active, .current, .disabled")
                        .removeClass("active current disabled");
                });
            },
            insertTitles = function () {
                //add title to second level
                $(
                    "li.hasChildren",
                    ".levels > .level-pos-container > .level-scroll-container > ul"
                ).each(function () {
                    var strong = $("<strong />").html($("> a", this).html()),
                        titleItem = $("<li />").prepend(strong),
                        nextLevel = $(this)
                        .find("ul")
                        .first();

                    nextLevel.prepend(titleItem);
                });
            },
            addOverviewLinks = function () {
                $(".levels ul ul li.hasChildren").each(function () {
                    var overviewLink = $("> a", this).clone(),
                        overviewItem = $("<li />").prepend(overviewLink),
                        nextLevel = $(this)
                        .find("ul")
                        .first();

                    nextLevel.prepend(overviewItem);
                });
            };

        prepare();
        insertTitles();
        // addOverviewLinks();
    },

    function Search() {
        var search = $("#search-top-wrapper"),
            searchTopToggler = $(".search-top-toggler");

        $(search).on("shown.bs.collapse", function (event) {
            search.find("input[type=text]:first").focus();
            event.stopPropagation();
        });

        $(searchTopToggler).on("keydown", function (event) {
            if (event.keyCode == 13) {
                if ($("body").hasClass("user-is-tabbing")) {
                    $(search)
                        .off("focusout")
                        .on("focusout", function () {
                            window.setTimeout(function () {
                                var focusInSearch =
                                    $(":focus", search).length == 1;

                                if (!focusInSearch) {
                                    $(search).off("focusout");
                                    $("#search-top-wrapper").collapse("hide");
                                    $(searchTopToggler)
                                        .next(":visible")
                                        .find("button")
                                        .focus();
                                }
                            }, 1);
                        });
                }
            }
        });
    },

    function WCAG() {
        var bindKeyEvents = function () {
            $(document).on("keydown, keyup", function (event) {
                /*
                 * Setting a class user-is-tabbing, if the user uses tab-navigation
                 * In this case, we can use special css-selectors
                 *
                 */
                if (event.keyCode == 9 || event.keyCode == 16) {
                    $("body").addClass("user-is-tabbing");
                }

                /*
                 * WCAG-Fix: If you are navigating with tab-key on the document, it is possible to go up, by pressing shift-tab
                 * and not seeing the focused item in the subnavigation anymore, because it's overlapped by the static header.
                 * In this case, this JS-Code checks this and scrolls to the focused element, so it is visible again.
                 */
                if (event.keyCode == 9 || event.keyCode == 16) {
                    var elementWithFocus = $(document).find(":focus");

                    if (elementWithFocus) {
                        var positionOfFocus =
                            elementWithFocus.offset().top -
                            $(window).scrollTop(),
                            headerHeight = $("#page-top").height();

                        if (positionOfFocus < headerHeight) {
                            $("html").scrollTop(
                                elementWithFocus.offset().top - headerHeight
                            );
                        }
                    }
                }
            });
        };

        // Beim Klick auf Suche in den Skiplinks, wird die Suche automatisch aufgeklappt - und der Focus gesetzt:
        var bindClickEvents = function () {
            var skiplinks = $("#skiplinks-container");

            $('a[href="#search"]', skiplinks).on("click", function () {
                var search = $("#search-top-wrapper");
                search.collapse("show");
                search.find("input[type=text]:first").focus();
            });
        };

        var watchSearchFilter = function () {
            var searchfilter = $("#searchfilter"),
                searchfilterToggler = $(".searchfilter-toggle");

            searchfilter.css("display", "none");

            $(searchfilter).on("show.bs.collapse", function () {
                searchfilter.css("display", "block");
                searchfilter.attr("role", "dialog").attr("aria-modal", "true");
            });

            // setting focus to first item of the mobile search-filter, when opening
            $(searchfilter).on("shown.bs.collapse", function () {
                searchfilter
                    .find("a")
                    .first()
                    .focus();
            });

            $(searchfilter).on("hide.bs.collapse", function () {
                searchfilter.css("display", "none");
            });

            $(searchfilter).on("focusout", function () {
                window.setTimeout(function () {
                    var focusIsOutsideSearchFilter =
                        searchfilter.find(":focus").length == 0,
                        focusIsValid = $(":focus").length != 0;

                    if (
                        !focusIsValid ||
                        (focusIsValid && focusIsOutsideSearchFilter)
                    ) {
                        $(searchfilter)
                            .find("button")
                            .first()
                            .focus();
                    }
                }, 200);
            });
        };

        bindKeyEvents();
        bindClickEvents();
        watchSearchFilter();
    }
]);
